<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Visitors from "./visitors";
import Posts from "./posts";
import Comments from "./comment";
import TopVisitor from "./top-visitor";
import Activity from "./activity";
import BlogPost from "./blog-post";
import Loader from "../../components/loader";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Supervisão",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Visitors,
    Posts,
    Comments,
    TopVisitor,
    Activity,
    BlogPost,
    Loader,
  },
  data() {
    return {
      updating: true,
      title: "Supervisão",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Supervisão",
          active: true,
        },
      ],
    };
  },
  mounted() {
    console.log('mounted_dashSupervisao')

    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    })
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>

      <Loader v-if="updating" style="min-height: 90px;">
      </Loader>

      <div class="row" v-if="!updating">
        <div class="col-xl-8">
          <div class="row">
            <div class="col-lg-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Composição Equipe</p>
                      <h5 class="mb-0">120</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-user-plus"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Orçamentos Hoje</p>
                      <h5 class="mb-0">R$ 860.840,00</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-note"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Pedidos Hoje</p>
                      <h5 class="mb-0">R$ 444.877,23</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-dollar-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->

          <div class="card">
            <Visitors />
          </div>
        </div>
        <!-- end col -->

        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="me-3">
                  <img
                    src="@/assets/images/users/avatar-2.jpg"
                    alt=""
                    class="avatar-sm rounded-circle img-thumbnail"
                  />
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <h5 class="mb-1">Destaque</h5>
                        <p class="mb-0">João de Souza</p>
                      </div>
                    </div>

                    <a href="" class="ms-2">
                      Mais detalhes
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </a>

                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Total Convertido</p>
                        <h5 class="mb-0">R$ 320.000,00</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Atendimento</p>
                        <h5 class="mb-0">84%</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <h5 class="card-title mb-3 me-2">Carteira de Clientes</h5>
                <b-dropdown
                  toggle-class="text-muted font-size-16 p-0"
                  variant="white"
                  right
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Acessar clientes</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Cadastrar novo cliente</b-dropdown-item>
                </b-dropdown>
              </div>

              <div class="d-flex flex-wrap">
                <div>
                  <p class="text-muted mb-1">Total Ativo</p>
                  <h4 class="mb-3">10.512</h4>
                  <p class="text-success mb-0">
                    <span
                      >65 % <i class="mdi mdi-arrow-top-right ms-1"></i
                    ></span>
                  </p>
                </div>
                <div class="ms-auto align-self-end">
                  <i class="bx bx-group display-4 text-light"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body p-4">
              <div class="text-center">
                <div class="avatar-md mx-auto mb-4">
                  <div
                    class="avatar-title bg-light rounded-circle text-primary h1"
                  >
                    <i class="mdi mdi-email-open"></i>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-xl-10">
                    <h4 class="text-primary">Receba Novidades!</h4>
                    <p class="text-muted font-size-14 mb-4">
                      Assine nossa newsletter e receba notificação para ficar atualizado.
                    </p>

                    <div class="input-group bg-light rounded">
                      <input
                        id="inputEmailDash02"
                        type="email"
                        class="form-control bg-transparent border-0"
                        placeholder="Entre com endereço de e-mail"
                        aria-label="Recipient's username"
                        aria-describedby="button-addon2"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-primary rounded"
                          type="button"
                          id="button-addon2"
                        >
                          <i class="bx bxs-paper-plane"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Loader v-if="updating" style="min-height: 530px;" class="mt-4">
      </Loader>


      <div class="row" v-if="!updating">
        <div class="col-xl-4 col-lg-6">
          <Posts />
        </div>
        <!-- end col -->

        <div class="col-xl-4 col-lg-6">
          <Comments />
        </div>
        <!-- end col -->

        <div class="col-xl-4">
          <TopVisitor />
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->

      <Loader v-if="updating" style="min-height: 110px;" class="mt-4">
      </Loader>

      <div class="row" v-if="!updating">
        <div class="col-xl-4">
          <Activity />
        </div>
        <!-- end col -->
        <div class="col-xl-8">
          <BlogPost />
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
  </Layout>
</template>
